module.exports = __webpack_public_path__ + "img/Cover_HW_20.0675b107.jpg";